const EVENTO_MODIFICADO = "Modified";
const EVENTO_ELIMINADO = "Deleted";
const EVENTO_MODIFICADO_LABEL = "Editado";
const EVENTO_ELIMINADO_LABEL = "Eliminado";

export class LogAuditoria {
  static getEventoLabel(evento) {
    switch (evento) {
      case EVENTO_MODIFICADO:
        return EVENTO_MODIFICADO_LABEL;
      case EVENTO_ELIMINADO:
        return EVENTO_ELIMINADO_LABEL;
    }
  }

  static get EVENTO_LIST() {
    return [
      { value: EVENTO_MODIFICADO, label: EVENTO_MODIFICADO_LABEL },
      { value: EVENTO_ELIMINADO, label: EVENTO_ELIMINADO_LABEL }
    ];
  };

  static get PROPIEDADES_EXPORTAR() {
    return [
      { value: "IdSec", label: "Id" },
      { value: "NombreUsuario", label: "Usuario" },
      { value: "IP", label: "IP" },
      { value: "Fecha", label: "Fecha" },
      { value: "Tabla", label: "Tabla" },
      { value: "Referencia", label: "ID en Tabla" },
      { value: "Evento", label: "Evento" },
      { value: "Campos", label: "Campos" },
      { value: "FechaCreacion", label: "Fecha Creación" }
    ];
  }
}
